/* hs-eslint ignored failing-rules */

/* eslint-disable react-hooks/exhaustive-deps */
'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import { useEffect } from 'react';
import getUsageTracker from 'pricing-pages-lib/utils/getUsageTracker';
import UIAlert from 'UIComponents/alert/UIAlert';
import styled from 'styled-components';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIButton from 'UIComponents/button/UIButton';
const AlertGrid = styled.div.withConfig({
  displayName: "PromotionBanner__AlertGrid",
  componentId: "sc-5yoqxx-0"
})(["display:grid;grid-template-columns:1fr auto;align-items:center;@media (max-width:767px){grid-template-columns:1fr;grid-template-rows:1fr auto;}"]);
const AlertTitle = styled.h5.withConfig({
  displayName: "PromotionBanner__AlertTitle",
  componentId: "sc-5yoqxx-1"
})(["font-weight:700;margin-right:20px;display:inline-block;margin-bottom:0;"]);
const AlertDescription = styled.div.withConfig({
  displayName: "PromotionBanner__AlertDescription",
  componentId: "sc-5yoqxx-2"
})(["display:inline-block;margin-top:4px;"]);

const PromotionBanner = (_ref) => {
  let {
    promotion,
    title,
    description,
    cta,
    dataSelenium,
    shouldShow = true
  } = _ref,
      rest = _objectWithoutPropertiesLoose(_ref, ["promotion", "title", "description", "cta", "dataSelenium", "shouldShow"]);

  useEffect(() => {
    if (shouldShow) {
      const name = `${promotion.toLowerCase()} promotion banner`;
      getUsageTracker().track('bannerInteraction', {
        name
      });
    }
  }, []);
  return shouldShow && /*#__PURE__*/_jsx(UIAlert, Object.assign({
    "data-selenium": dataSelenium,
    type: "info"
  }, rest, {
    children: /*#__PURE__*/_jsxs(AlertGrid, {
      style: cta ? {
        gridColumnGap: '16px',
        gridRowGap: '16px'
      } : {},
      children: [/*#__PURE__*/_jsxs("div", {
        children: [/*#__PURE__*/_jsx(AlertTitle, {
          children: title
        }), /*#__PURE__*/_jsx(AlertDescription, {
          children: description
        })]
      }), cta && /*#__PURE__*/_jsx("div", {
        children: /*#__PURE__*/_jsx(UIButton, {
          href: cta.url,
          use: "tertiary",
          size: "small",
          style: {
            width: '100%'
          },
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: cta.message
          })
        })
      })]
    })
  }));
};

PromotionBanner.propTypes = {
  promotion: PropTypes.string.isRequired,
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  description: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  cta: PropTypes.shape({
    message: PropTypes.string,
    url: PropTypes.string
  }),
  dataSelenium: PropTypes.string,
  shouldShow: PropTypes.bool
};
export default PromotionBanner;